/**
 * Event handler function for sliders in agendas
 * @param {string} agendaName	session name
 * @param {string} sliderId		DOM ID of the slider
 * @param {number} position		position is 0-based	(offset)
 * @param {number} pageSize		size of one page (number of rows)
 * @param {number} total		total number of rowsy
 */
export function hookAgendaSlider(agendaName, sliderId, position, pageSize, total) {
	var slider = $('#' + sliderId);
	slider.on('change', function() {
		let p = parseInt($(this).val().toString())-1;
		window.location = 'pager.do?agenda='+agendaName+"&dir=pos&pos="+p;
	}).on('input', function() {
		$('.'+agendaName+'_from').text($(this).val());
		let toVal = parseInt($(this).val().toString())+pageSize-1;
		if (toVal > total) toVal = total;
		$('.'+agendaName+'_to').text(toVal);
	});
}
